/**
 * Vista: Lista de Check Lists de Ensamble
 * Formato: AMX-PR-FR-02
 */

import produccionService from '../services/produccion.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Check Lists de Ensamble</h2>
          ${permisos.canCreate('checklists') ? `
            <button class="btn btn-primary" onclick="router.navigate('/produccion/checklists/nuevo')">
              + Nuevo Check List
            </button>
          ` : ''}
        </div>

        <!-- Estadísticas rápidas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statCompletados" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Completados</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statPendientes" style="font-size: 1.5rem; font-weight: bold; color: var(--warning);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Pendientes</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statPromedio" style="font-size: 1.5rem; font-weight: bold; color: var(--primary);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">% Promedio</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Modelo o Técnico"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="completadoFilter" class="form-select">
              <option value="">Todos</option>
              <option value="true">Completados</option>
              <option value="false">Pendientes</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.checklistsListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Marca</th>
                <th class="tbl-hide-mobile">Progreso</th>
                <th class="tbl-hide-mobile">Técnico</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="checklistsTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando checklists...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('checklists')) {
      if (permisos.primeraRuta) {
        router.navigate(permisos.primeraRuta);
      } else {
        document.getElementById('content').innerHTML = `
          <div style="display: flex; justify-content: center; align-items: center; height: 60vh;">
            <div style="text-align: center; color: var(--gray-500);">
              <h2>Acceso denegado</h2>
              <p>No tienes permisos para acceder a este módulo.</p>
            </div>
          </div>
        `;
      }
      return;
    }
    window.checklistsListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarChecklists();
      }, 500);
    });

    document.getElementById('completadoFilter').addEventListener('change', (e) => {
      this.filters.completado = e.target.value;
      this.currentPage = 1;
      this.cargarChecklists();
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarChecklists();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarChecklists();
    });

    await this.cargarEstadisticas();
    await this.cargarChecklists();
  },

  async cargarEstadisticas() {
    try {
      const response = await produccionService.obtenerEstadisticasChecklists();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.total || 0;
      document.getElementById('statCompletados').textContent = stats.completados || 0;
      document.getElementById('statPendientes').textContent = stats.pendientes || 0;
      document.getElementById('statPromedio').textContent =
        stats.promedio_completitud ? `${parseFloat(stats.promedio_completitud).toFixed(1)}%` : '0%';
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarChecklists() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await produccionService.listarChecklists(params);
      const checklists = response.data || response.checklists || response;
      const pagination = response.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderChecklists(Array.isArray(checklists) ? checklists : []);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar checklists');
      console.error('Error:', error);
      this.renderChecklists([]);
    }
  },

  renderChecklists(checklists) {
    const tbody = document.getElementById('checklistsTableBody');

    if (!checklists || checklists.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" style="text-align: center; padding: 2rem;">
            No se encontraron checklists
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = checklists.map(c => {
      const fp = (c.fecha || '').substring(0, 10).split('-');
      const fechaStr = fp.length === 3 ? `${fp[2]}/${fp[1]}/${fp[0]}` : '-';
      const pct = parseFloat(c.porcentaje_completitud || 0).toFixed(0);
      const progressHtml = `
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <div style="flex: 1; background: var(--bg-secondary); border-radius: 4px; height: 8px; overflow: hidden;">
            <div style="width: ${c.porcentaje_completitud || 0}%; height: 100%; background: ${this.getProgressColor(c.porcentaje_completitud)};"></div>
          </div>
          <span style="font-size: 0.75rem; min-width: 40px;">${pct}%</span>
        </div>
      `;
      const estadoBadge = `<span class="badge badge-${c.completado ? 'success' : 'warning'}">${c.completado ? 'Completado' : 'Pendiente'}</span>`;
      const accionesHtml = `
        ${c.completado
          ? (permisos.canView('checklists') ? `<button class="btn btn-sm btn-primary" onclick="window.checklistsListView.verDetalle(${c.id})">Ver</button>` : '')
          : `${permisos.canEdit('checklists') ? `<button class="btn btn-sm btn-primary" onclick="window.checklistsListView.verDetalle(${c.id})">Editar</button>` : ''}
             ${permisos.canDelete('checklists') ? `<button class="btn btn-sm btn-danger" onclick="window.checklistsListView.eliminar(${c.id}, '${c.num_serie}')">Eliminar</button>` : ''}`
        }
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.checklistsListView.toggleRow(${c.id})">&#9654;</button></td>
        <td><strong>${c.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${fechaStr}</td>
        <td class="tbl-hide-mobile">${c.modelo}</td>
        <td class="tbl-hide-mobile">${c.marca || '-'}</td>
        <td class="tbl-hide-mobile">${progressHtml}</td>
        <td class="tbl-hide-mobile">${c.tecnico_ensamble || '-'}</td>
        <td class="tbl-hide-mobile">${estadoBadge}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-chk-${c.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaStr}</dd>
            <dt>Modelo</dt><dd>${c.modelo}</dd>
            <dt>Marca</dt><dd>${c.marca || '-'}</dd>
            <dt>Progreso</dt><dd>${pct}%</dd>
            <dt>Técnico</dt><dd>${c.tecnico_ensamble || '-'}</dd>
            <dt>Estado</dt><dd>${estadoBadge}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  getProgressColor(porcentaje) {
    if (porcentaje >= 100) return 'var(--success)';
    if (porcentaje >= 75) return 'var(--primary)';
    if (porcentaje >= 50) return 'var(--warning)';
    return 'var(--danger)';
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.checklistsListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.checklistsListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.checklistsListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-chk-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarChecklists();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('completadoFilter').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarChecklists();
  },

  verDetalle(id) {
    router.navigate(`/produccion/checklists/${id}`);
  },

  eliminar(id, numSerie) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar el check list del tractor <strong>${numSerie}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await produccionService.eliminarChecklist(id);
          toast.success('Check list eliminado exitosamente');
          await this.cargarEstadisticas();
          await this.cargarChecklists();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar check list');
          console.error(error);
        }
      }
    );
  }
};
